import { useAppSelector } from '../../../../../../../../redux/store.model';
import { getMyWorkspaceSelector } from '../../../../../../../../redux/workspace/selectors/Workspace.selectors';
import { ITypeRequest } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import useStructuresWorkspaces from './useStructuresWorkspaces';
import useStructuresWorkspace from './useStructuresWorkspace';
import { useMemo } from 'react';

interface IUseCommanderOfflineProps {
  groupId?: string;
  workspaceId?: string;
  typeRequest: ITypeRequest;
}
function useStructures(props: IUseCommanderOfflineProps) {
  const { typeRequest, workspaceId } = props;

  const structuresWorkspaces = useStructuresWorkspaces({ typeRequest });
  const structureWorkspace = useStructuresWorkspace({
    typeRequest,
    workspaceId,
  });

  const myWorkspace = useAppSelector(getMyWorkspaceSelector);
  const structureWorkspaceMappedData = useMemo(
    () => ({
      ...structureWorkspace,
      data: structureWorkspace.data ? [structureWorkspace.data] : undefined,
      originalArgs: [workspaceId ?? myWorkspace?.id],
    }),
    [myWorkspace?.id, structureWorkspace, workspaceId]
  );
  switch (typeRequest) {
    case 'workspaces':
      return structuresWorkspaces;
    default:
      return structureWorkspaceMappedData;
  }
}

export default useStructures;
